import { InvitationPage } from 'app/BCKSPage/Invitation'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PropsInvitationIndexPage {
  isKSSelectionEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const InvitationIndexPage = (props: PropsInvitationIndexPage) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <InvitationPage />
}

// eslint-disable-next-line react/display-name
InvitationIndexPage.Layout = ({ children }) => children

export default InvitationIndexPage
